
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 133798"}},[_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/frame"}},[_c('g',{attrs:{"data-name":"Group 133546"}},[_c('path',{attrs:{"d":"M8.718 15.566L5.726 12.58"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.718 5.434v10.132"}})]),_c('g',{attrs:{"data-name":"Group 661"}},[_c('path',{attrs:{"data-name":"Vector","d":"M12.283 5.434l2.992 2.986M12.283 15.566V5.434"}})])])])])
          )
        }
      }
    